/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_View_More_Options_ButtonInputs */

const en_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View More Options`)
};

const fr_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir plus d'options`)
};

const de_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Optionen anzeigen`)
};

const it_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza altre opzioni`)
};

const ru_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть дополнительные параметры`)
};

const es_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver más opciones`)
};

const zh_cn2_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看更多选项`)
};

const ja_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のオプションを表示`)
};

const hi_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक विकल्प देखें`)
};

const pt_pt2_new_project_view_more_options_button = /** @type {(inputs: New_Project_View_More_Options_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver mais opções`)
};

/**
* | output |
* | --- |
* | "View More Options" |
*
* @param {New_Project_View_More_Options_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_view_more_options_button = /** @type {((inputs?: New_Project_View_More_Options_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_View_More_Options_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_view_more_options_button(inputs)
	if (locale === "de") return de_new_project_view_more_options_button(inputs)
	if (locale === "it") return it_new_project_view_more_options_button(inputs)
	if (locale === "ru") return ru_new_project_view_more_options_button(inputs)
	if (locale === "es") return es_new_project_view_more_options_button(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_view_more_options_button(inputs)
	if (locale === "ja") return ja_new_project_view_more_options_button(inputs)
	if (locale === "hi") return hi_new_project_view_more_options_button(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_view_more_options_button(inputs)
	return en_new_project_view_more_options_button(inputs)
});